import React from 'react';
import exact from 'prop-types-exact';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { compose, withProps } from 'recompose';
import { Col, Row, Table } from 'react-bootstrap';


import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';
import { nodeType } from '../../../propTypes';
import { getKGSLink } from '../links';
import NewTabLink from '../../../components/NewTabLink/index';
import '../style.css';

const propTypes = exact({
  ticket: nodeType,
});


const TicketFacts = (props) => {
  const { ticket } = props;
  const { job, well, date, department, district, ticket_number: ticketNumber } = ticket;
  const { lease, name: wellName } = well;
  const { operator, customer, tax_schedule: taxSchedule, name: leaseName } = lease;
  const { name: operatorName } = operator;

  const { display: dateDisplay } = date;
  const { number: ticketNumberDisplay } = ticketNumber;
  const { job_number: jobNumber, invoice_number: invoiceNumber } = job;

  const equipment = querySelector(ticket.equipment, '$.edges[*].node', []);
  const equipmentJoined = equipment.map((eq) => { return eq.equipment_number; }).join(', ');

  const { name: departmentName } = department;
  const { name: districtName } = district;

  const customerName = (customer) ? customer.display_name : '';
  const taxScheduleName = (taxSchedule) ? taxSchedule.display_name : '';

  return (
    <Row>
      <Col xs={4}>
        <Table condensed>
          <tbody>
            <tr>
              <td className="text-right"><strong>Date:</strong></td>
              <td className="text-left">{dateDisplay}</td>
            </tr>
            <tr>
              <td className="text-right"><strong>Department:</strong></td>
              <td className="text-left">{departmentName}</td>
            </tr>
            <tr>
              <td className="text-right"><strong>District:</strong></td>
              <td className="text-left">{districtName}</td>
            </tr>
            <tr>
              <td className="text-right"><strong>Invoice #:</strong></td>
              <td className="text-left">{invoiceNumber}</td>
            </tr>
          </tbody>
        </Table>
      </Col>
      <Col xs={4}>
        <Table condensed>
          <tbody>
            <tr>
              <td className="text-right"><strong>Equipment:</strong></td>
              <td className="text-left">{equipmentJoined}</td>
            </tr>
            <tr>
              <td className="text-right"><strong>Ticket:</strong></td>
              <td className="text-left">{ticketNumberDisplay}</td>
            </tr>
            <tr>
              <td className="text-right"><strong>Job:</strong></td>
              <td className="text-left">{jobNumber}</td>
            </tr>
            <tr>
              <td className="text-right"><strong>Acct. Tax Schedule:</strong></td>
              <td className="text-left">{taxScheduleName}</td>
            </tr>
          </tbody>
        </Table>
      </Col>
      <Col xs={4}>
        <Table condensed>
          <tbody>
            <tr>
              <td className="text-right"><strong>Operator:</strong></td>
              <td className="text-left">{operatorName}</td>
            </tr>
            <tr>
              <td className="text-right"><strong>Lease:</strong></td>
              <td className="text-left">{leaseName}</td>
            </tr>
            <tr>
              <td className="text-right"><strong>Well:</strong></td>
              <td className="text-left">
                <span className="pull-left">{wellName}</span>
                <NewTabLink to={getKGSLink(operatorName, leaseName)}>
                  <span className="kgs-link">(KGS)</span>
                </NewTabLink>
              </td>
            </tr>
            <tr>
              <td className="text-right"><strong>Acct. Customer:</strong></td>
              <td className="text-left">{customerName}</td>
            </tr>
          </tbody>
        </Table>
      </Col>
    </Row>
  );
};


TicketFacts.propTypes = propTypes;


export const Query = gql`
  query TicketView($ticketId: Int!) {
    ticket(ticket_id: $ticketId) {
      id
      date {
        display
      }
      ticket_number {
        id
        number
      }
      job {
        id
        job_number
        invoice_number
      }
      department {
        id
        name
      }
      district {
        id
        name
      }
      well {
        id
        name
        lease {
          id
          name
          customer {
            id
            customer_name
            display_name
          }
          tax_schedule {
            id
            description
            display_name
          }
          operator {
            id
            name
          }
        }
      }
      equipment {
        edges {
          node {
            id
            equipment_number
            equipment_type
          }
        }
      }
    }
  }
`;


const withData = graphql(Query, {
  options: { fetchPolicy: 'network-only' },
});


const mapDataToProps = withProps((props) => {
  const { data: { ticket } } = props;
  return {
    ticket,
  };
});


const enhance = compose(
  withData,
  queryMetaHandler,
  mapDataToProps,
  omitProps(['data', 'ticketId']),
);


export default enhance(TicketFacts);
